import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getForeignerlevyCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetForeignerlevy}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getForeignerlevyById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetForeignerlevy}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertForeignerlevy = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.GetForeignerlevy,
    input
  );
  return data;
};

const updateForeignerlevy = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.GetForeignerlevy,
    input
  );
  return data;
};

const deleteForeignerlevy = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.GetForeignerlevy}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useForeignerlevyCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetForeignerlevy],
    queryFn: () => getForeignerlevyCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetForeignerlevyByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetForeignerlevy],
    queryFn: () => getForeignerlevyById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertForeignerlevyMutation = () => {
  return useMutation({
    mutationFn: insertForeignerlevy,
  });
};

export const useUpdateForeignerlevyMutation = () => {
  return useMutation({
    mutationFn: updateForeignerlevy,
  });
};

export const useDeleteForeignerlevyMutation = () => {
  return useMutation({
    mutationFn: deleteForeignerlevy,
  });
};
